import React from "react";

import styles from "./Guides.module.css";

const ColumnGuides = ({ columnWidth, gutterWidth, columnCount, stageWidth }) => {
  return (
    <div
      style={{ margin: "0 auto", height: "100%", position: "relative", width: `${stageWidth}px` }}
    >
      {Array(columnCount + 1)
        .fill(0)
        .map((_, i) => (
          <div
            key={`col-${i}`}
            className={styles.columnGuide}
            style={{
              width: `${gutterWidth}px`,
              left: `${(columnWidth + gutterWidth) * i}px`,
            }}
          ></div>
        ))}
    </div>
  );
};

export default ColumnGuides;
